module.exports = __webpack_public_path__ + "img/uruguay.9af017be.png";